import moment, { Moment } from "moment";

// we will add more later
export const currentDate = (): Moment => moment(Date.now());

export const defaultDateFormat = (date = Date.now()): string => {
  return moment(date).format("MMM-DD-YYYY hh:mm:ss A");
};
